var map = {
	"./Chasseur.png": "b6c1",
	"./Cupidon.png": "fe20",
	"./Dictateur.png": "f676",
	"./Gardien.png": "db81",
	"./Loup garou.png": "80d0",
	"./Petite Fille.png": "1957",
	"./Sorcière.png": "6333",
	"./Villageois.png": "09fd",
	"./Voyante.png": "1929"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";